export default __webpack_public_path__ + "static/media/ic_center_focus_weak_24px.9007e62a.svg";